module.exports = __webpack_public_path__ + "media/music.297893b1.mp3";